import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { GetCurrencySymbol } from '../../../../../../utils/Currency';
import { GetFloatNumber } from '../../../../../../utils/NumberFormatter';
import { EyeIcon } from '../../../../../../utils/SVGIcon';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function SubscriptionInvoiceTr({ item }) {
    const navigate = useNavigate();
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td
                onClick={() => navigate(mkRelativeUrl(`/billing/invoices/${item?.id}/info`))}
                className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer"
            >
                <span>{item?.invoiceTitle}</span>
            </td>
            <td
                className={cn({
                    'group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer':
                        item?.organization?.length
                })}
            >
                <Link to={`/agency/${item?.agencyId}/customers/${item?.userId}/info`}>
                    <span>{item?.organization || '-----'}</span>
                </Link>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeIssue) || 'No Issue Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeDue) || 'No Due Date'}</span>
            </td>
            <td className="text-center">
                <span>{item?.currency}</span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amountBilled || 0)}
                </span>
            </td>
            <td className="text-center">
                <span>
                    {GetCurrencySymbol(item?.currency)}
                    {GetFloatNumber(item?.amountPaid || 0)}
                </span>
            </td>
            <td>
                <span>
                    <button
                        type="button"
                        onClick={() =>
                            navigate(mkRelativeUrl(`/billing/invoices/${item?.id}/info`))
                        }
                        data-tooltip-id="myToolTip"
                        data-tooltip-content="View Invoice"
                        className="size-[31px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    );
}

function SubscriptionInvoiceTableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col">
                    <span>Title</span>
                </th>
                <th scope="col">
                    <span>Customer Info.</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Issue Date</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Due Date</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Currency</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Bill Amount</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Paid Amount</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}
function TableWeb({ data }) {
    return (
        <div className="subscription_invoice_tab mb-52">
            <table className="bik-table pb-7" cellPadding={0} cellSpacing={0}>
                <SubscriptionInvoiceTableHeader />
                <tbody>
                    {data && data?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={9} className="!text-left">
                                No Invoice Found!
                            </td>
                        </tr>
                    ) : (
                        data?.map((item) => <SubscriptionInvoiceTr key={item.id} item={item} />)
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
